import {
  DatagridConfigurable,
  List,
  TextField,
  TopToolbar,
  SelectColumnsButton,
  CreateButton,
  SearchInput,
} from "react-admin";

import { DateFieldWithStandardFormat } from "@/fields/DateFieldWithStandardFormat";

const ListActions = () => (
  <TopToolbar>
    <SelectColumnsButton />
    <CreateButton />
  </TopToolbar>
);

export const LandingsList = () => (
  <List
    actions={<ListActions />}
    filters={[
      <SearchInput
        key="search"
        source="q"
        placeholder="Search Landings"
        alwaysOn
      />,
    ]}
    storeKey={false}
    pagination={false}
  >
    <DatagridConfigurable bulkActionButtons={false}>
      <TextField source="id" sortable={false} />
      <TextField source="title" sortable={false} />
      <TextField source="appLandingId" sortable={false} />
      <TextField source="showAcceptPrivacy" label="Show Accept Privacy:" />
      <DateFieldWithStandardFormat source="createdAt" sortable={false} />
      <DateFieldWithStandardFormat source="updatedAt" sortable={false} />
    </DatagridConfigurable>
  </List>
);
